import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { OrderStatus } from '../../order-list/interface/order-list.interface';
import { OrderService } from '../../order/service/order.service';
import { OrderState } from '../../order/state/order.state';

export const orderReferenceIdGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  _router: Router = inject(Router),
  orderService: OrderService = inject(OrderService),
  orderState: OrderState = inject(OrderState)
) => {
  const referenceId = _route.paramMap.get('referenceId')!;

  return orderService.getOrderDetail(null, referenceId).pipe(
    map(() => {
      /** Strip the query string and fragment so the route check is not defeated by `?readonly=true` or `#section`. */
      const isViewUrl = _state.url.split(/[?#]/)[0].endsWith('/view');

      if (orderState.orderDetail.orderStatus == OrderStatus.draft) {
        _router.navigate(['/orders', orderState.orderDetail.id, 'match-subject'], {
          replaceUrl: true,
          queryParams: _route.queryParams,
        });
        return false;
      }

      if (isViewUrl) {
        _router.navigate(['/orders', orderState.orderDetail.id, 'view'], {
          replaceUrl: true,
          queryParams: _route.queryParams,
        });
      } else {
        _router.navigate(['/orders', orderState.orderDetail.id], { replaceUrl: true, queryParams: _route.queryParams });
      }

      return false;
    }),
    catchError(() => {
      _router.navigate(['/orders'], { replaceUrl: true });
      return of(false);
    })
  );
};
